<template lang="pug">
  .main
    router-view
</template>

<script>
export default {
  name: 'User'
}
</script>

<style lang="scss" scoped >

    
// @media (min-width: 800px) {
// .title {
//     width: 70%;
// }
//  .main {
//     width: 70%;
//     padding: 0 15vw;
//   }
  
// }
// @media (min-width: 800px) {
//   .title {
//       width: 70%;
//   }
    
//   }
    
// @media (min-width: 1000px) {
// .title {
//     width: 60%;
// }
//  .main {
//     width: 50%;
//     padding: 0 25vw;
//   }
  
// }
</style>